export const ERRORS = {};
//http errors
ERRORS.HTTP_403_ERROR = "HTTP_403_ERROR";
ERRORS.HTTP_404_ERROR = "HTTP_404_ERROR";
ERRORS.HTTP_500_ERROR = "HTTP_500_ERROR";
ERRORS.HTTP_503_ERROR = "HTTP_503_ERROR";
ERRORS.HTTP_802_ERROR = "HTTP_802_ERROR";
ERRORS.HTTP_OTHER_ERROR = "HTTP_OTHER_ERROR";
ERRORS.CLOSE_ERROR_MODAL = "CLOSE_ERROR_MODAL";
